export default {
  name: 'CodeCanyon',
  abbreviation: 'CC',
  domain: 'codecanyon.net',
  google_analytics_id: 'UA-11834194-12',
  google_remarketing_label: 'bdtlCM3-uQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. ecommerce plugin',
  experimentsLoadingCover: true,
  filterOrder: [
    'category',
    'tags',
    'price',
    'software-version',
    'compatible-with',
    'sales',
    'rating',
    'date-added',
    'date-updated'
  ],
  features: {
    /**
     * @description Enables new category page design
     * @author Pawel Galazka
     * @expires when category pages experiment is over for all markets
     */
    categoryRedesign: true
  },
  surveys: {
    search: {
      url: 'https://forms.gle/D1VrUp7NdnGDMsTNA',
      text:
        'Please complete our 2 minute survey to help improve your experience',
      linkText: 'Click here',
      minSearchCountToShow: 2
    },
    category: {
      url: 'https://forms.gle/1wZ9FvRWyxCxaWcP6',
      text:
        'Please complete our 2 minute survey to help improve your experience',
      linkText: 'Click here',
      minSearchCountToShow: 2
    }
  }
}
